<div class="filter-wrapper">
<div *ngFor="let item of picklistProperties?.Values">
  <label class="k-form-field">
    <input type="checkbox" class="k-checkbox" [(ngModel)]="dictionary[item.Value]" id="{{item.Value}}" (change)="modelChanged($event, item)">
    <label class="k-checkbox-label" for="{{item.Value}}" >{{item.Value}}</label>
  </label>
</div>
</div>
